module.exports = __webpack_public_path__ + "static/media/logout.28fb4883.svg";